module.exports = __webpack_public_path__ + "img/V.173cad36.svg";